module.exports = __webpack_public_path__ + "static/media/No Words Required (ft Chris Swartwood).b5725fae.jpg";